import React from 'react';
import ContentLoader from 'react-content-loader';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const TreeMapLoader = () => /*#__PURE__*/_jsx("div", {
  className: styles.loader,
  children: /*#__PURE__*/_jsxs(ContentLoader, {
    style: {
      width: 'auto',
      height: '90%'
    },
    viewBox: "0 0 400 400",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "0",
      width: "45%",
      height: "74.5%"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "75%",
      width: "45%",
      height: "25%"
    }), /*#__PURE__*/_jsx("rect", {
      x: "45.5%",
      y: "0",
      width: "54.9%",
      height: "59.5%"
    }), /*#__PURE__*/_jsx("rect", {
      x: "45.5%",
      y: "60%",
      width: "54.9%",
      height: "40%"
    })]
  })
});

export default TreeMapLoader;